import { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

const ELEMENT_ID = 'hw-qr-reader';

export default function QrScanView({ onScan, hint, errorText }) {
  const [camError, setCamError] = useState(null);
  const onScanRef = useRef(onScan);

  useEffect(() => {
    onScanRef.current = onScan;
  }, [onScan]);

  useEffect(() => {
    const scanner = new Html5Qrcode(ELEMENT_ID);
    let running = false;

    scanner
      .start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 220, height: 220 } },
        (text) => {
          running = false;
          scanner.stop().catch(() => {});
          onScanRef.current(text);
        },
        () => {}, // per-frame decode error — expected, ignore
      )
      .then(() => {
        running = true;
      })
      .catch((err) => {
        setCamError(err?.message || 'Camera unavailable');
      });

    return () => {
      if (running) {
        scanner
          .stop()
          .catch(() => {})
          .finally(() => scanner.clear().catch(() => {}));
      } else {
        scanner.clear().catch(() => {});
      }
    };
  }, []);

  if (camError) {
    return (
      <div className="flex flex-col items-center justify-center py-8 gap-3 text-center">
        <i className="fa fa-video-slash text-4xl text-gray-200" />
        <p className="text-sm text-red-500 max-w-[220px]">{errorText || camError}</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div id={ELEMENT_ID} className="w-full rounded-xl overflow-hidden" />
      {hint && <p className="text-xs text-center text-gray-400">{hint}</p>}
    </div>
  );
}
